module.exports = __webpack_public_path__ + "img/location-xmark.a383b49e.svg";